<div class="checklist">
  <div class="option" *ngFor="let option of options; trackBy: trackByFn"
       [class.available]="option.available"
       (click)="option.available ? onActionClick(option) : null">
    <app-icon class="option__icon" [file]="'unboarding'" [icon]="option.checked ? 'circle-checked' : 'circle'"></app-icon>

    <ng-container *ngIf="option.available">
      <span class="option__link">{{ option.label | customLocale }}</span>
      <app-icon class="option__icon2" [file]="'unboarding'" [icon]="'arrow-filled'"></app-icon>
    </ng-container>

    <ng-container *ngIf="!option.available">
      <span class="option__label">{{ option.label | customLocale }}</span>
      <app-icon class="option__icon2" [file]="'unboarding'" [icon]="'arrow'"></app-icon>
    </ng-container>
  </div>
</div>
